import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@chargify/icons';
import { Tooltip } from '@chargify/custom-ui-components';
import { InvoiceConsolidationLevel } from '../../../models/billingHistory/billingHistory';

type IconWIthTooltipProps = {
  consolidationLevel: InvoiceConsolidationLevel;
};
export const IconWIthTooltip = ({
  consolidationLevel,
}: IconWIthTooltipProps) => {
  const { t } = useTranslation('billing-history');
  switch (consolidationLevel) {
    case 'none':
      return (
        <Tooltip
          renderContent={() => (
            <Tooltip.Text message={t('normal_invoice') as string} />
          )}
        >
          <Icon fill={'gray.light'} type={'file'} size={16} />
        </Tooltip>
      );
    case 'parent':
      return (
        <Tooltip
          renderContent={() => (
            <Tooltip.Text message={t('consolidated_invoice') as string} />
          )}
        >
          <Icon fill={'gray.light'} type={'filePlus'} size={16} />
        </Tooltip>
      );
    case 'child':
      return (
        <Tooltip
          renderContent={() => (
            <Tooltip.Text
              message={t('consolidated_invoice_segment') as string}
            />
          )}
        >
          <Icon fill={'gray.light'} type={'fileSolid'} size={16} />
        </Tooltip>
      );
  }
};
